
export interface IUser {
  agreedToTerms: Date | null;
  avatar: string;
  bio: string;
  dateCreated: Date;
  email: string;
  employeeOrSpouse: string;
  extra: string;
  firstName: string;
  fitbitLastRefreshDate: Date | null;
  fitbitEnabled: boolean;
  goals: any[];
  isAdmin: boolean;
  isBoothHost: boolean;
  isClientContact: boolean;
  isDietitian: boolean;
  isHealthFairHost: boolean;
  isMainstagePresenter: boolean;
  isTester: boolean;
  isVendorBoothHost: boolean;
  lastName: string;
  loginCount: number;
  nameOrNickname: string;
  nickname: string;
  registrations: IRegistration[];
  _id: string;
  _location: string;
  vendorBooths?:string[];
  clientContactAccessAckDate: Date;
}

export interface IRegistration {
  bundleRegistrations: IBundleRegistration[];
  dateRegistered:Date;
  solutionId: string;
  userId: string;
  _id: string;
}

export interface IBundleRegistration {
  bundleId:string;
  url:string;
  _id: string;
}

export const generateAvatarURL = (avatar) => {
  if(avatar) {
    if(avatar.charAt(0)=='/') return avatar;
    else return '/usercontent/'+avatar;
  } else {
    return '';
  }
}
